import CalendarEntry from 'owa-service/lib/contract/CalendarEntry';
import FolderId from 'owa-service/lib/contract/FolderId';
import LinkedCalendarEntry from 'owa-service/lib/contract/LinkedCalendarEntry';
import LocalCalendarEntry from 'owa-service/lib/contract/LocalCalendarEntry';

export default function getCalculatedFolderId(
    calendar: CalendarEntry | LocalCalendarEntry
): FolderId {
    if ((calendar as LocalCalendarEntry).CalendarFolderId !== undefined) {
        // local calendar entry
        return (calendar as LocalCalendarEntry).CalendarFolderId;
    }
    let linkedCalendarEntry: LinkedCalendarEntry = calendar;
    return linkedCalendarEntry.IsGeneralScheduleCalendar
        ? { Id: linkedCalendarEntry.OwnerEmailAddress, ChangeKey: '' }
        : linkedCalendarEntry.SharedFolderId
        ? {
              Id: linkedCalendarEntry.SharedFolderId.Id,
              ChangeKey:
                  linkedCalendarEntry.SharedFolderId.ChangeKey != null
                      ? linkedCalendarEntry.SharedFolderId.ChangeKey
                      : '',
          }
        : null;
}
